import * as Sentry from '@sentry/browser';

import { getConfig } from '@adminhub/config/config';

export const initSentry = (): ReturnType<typeof Sentry.init> =>
	Sentry.init(getConfig().sentryConfig);

export interface SentryUserContext {
	id: string;
	email?: string;
	name?: string;
	locale?: string;
}

export const setSentryUser = (_user: SentryUserContext | null): void => {
	Sentry.setUser(null);
};
